import React from 'react';
import tw from "tailwind-styled-components";

const CategoriesLoading = () => {
    return (
        <Container>
            {[...Array(2)].map((_, index) => (
                <SectionWrapper key={index}>
                    <SectionTitle />
                    <ItemsGrid>
                        {[...Array(index === 0 ? 4 : 8)].map((_, idx) => (
                            <CategoryItem key={idx}>
                                <Image />
                                <Text />
                            </CategoryItem>
                        ))}
                    </ItemsGrid>
                </SectionWrapper>
            ))}
        </Container>
    );
};

const Container = tw.div`animate-pulse w-full`;
const SectionWrapper = tw.div`p-4 pt-1 md:px-8`;
const SectionTitle = tw.div`h-6 bg-gray-200 rounded w-48 my-3`;
const ItemsGrid = tw.div`grid grid-cols-2 md:grid-cols-4 gap-4 p-3 border border-gray-300 md:border-0 rounded-lg`;
const CategoryItem = tw.div`flex flex-col items-center justify-center gap-2 p-1`;
const Image = tw.div`h-32 w-32 bg-gray-200 rounded-lg`;
const Text = tw.div`h-4 w-28 bg-gray-200 rounded`;

export default CategoriesLoading;
